<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrap">
        <p class="updateTips">
          您正在进行重要操作，为保证您的数据安全，请验证您的手机号
        </p>
        <van-form :label-position="'right'" label-width="64px">
          <van-field
            v-if="hasPhone"
            label="手机号"
            :value="phoneNum"
            readonly
            disabled
          />
          <van-field
            v-else
            v-model="phoneNum"
            type="tel"
            label="手机号"
            placeholder="请填写手机号"
            clearable
          />
          <van-field
            class="vailCodeInput"
            v-model="verCode"
            center
            clearable
            label="验证码"
            placeholder="请输入短信验证码"
          >
            <template #button>
              <van-button
                size="small"
                class="getCodeBtn"
                @click="getCode"
                :type="codeBtnType"
                :disabled="codeBtnStatus"
                >{{ codeBtnText }}</van-button
              >
            </template>
          </van-field>
          <van-button
            class="largeCenterBtn"
            :type="submitBtnType"
            :disabled="disableSubmitBtn"
            @click="authCode"
            >确认</van-button
          >
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getVerCode, getStudioDetail } from '@/api/studio';
import { mapState } from 'vuex';
const ORG_CODE_BTN_TEXT = '获取验证码';
export default {
  data() {
    return {
      submitBtnType: 'primary',
      // submitBtnStatus: true,
      codeBtnType: 'primary',
      codeBtnStatus: true,
      codeBtnText: ORG_CODE_BTN_TEXT,
      phoneNum: '',
      verCode: '',
      hasPhone: false,
    };
  },
  created() {
    let studioBaseInfo = JSON.parse(
      sessionStorage.getItem('studioBaseInfo') || '{}',
    );
    this.phoneNum = studioBaseInfo.phone;
    this.hasPhone = !!this.phoneNum;
    console.log('created', sessionStorage.getItem('studioBaseInfo'));
  },
  computed: {
    ...mapState(['userInfo']),
    disableSubmitBtn() {
      return !(
        this.phoneNum &&
        this.verCode &&
        (this.hasPhone || this.isvalidPhone(this.phoneNum))
      );
    },
  },
  watch: {
    phoneNum: function (val) {
      if (this.isvalidPhone(val)) {
        this.setBtnEnable('code');
      } else {
        this.setBtnDisabled('code');
      }
    },
  },
  methods: {
    isvalidPhone(str) {
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
      return this.hasPhone || reg.test(str);
    },
    getCode() {
      if (this.codeBtnStatus) return;
      if (this.phoneNum && this.isvalidPhone(this.phoneNum)) {
        getVerCode({ phone: this.phoneNum, tk: this.userInfo.tk }).then(() => {
          this.setBtnDisabled('code');
          let seconds = 60;
          this.codeBtnText = seconds + 's';
          let timer = setInterval(() => {
            this.codeBtnText = --seconds + 's';
            if (seconds <= 0) {
              clearInterval(timer);
              timer = null;
              this.codeBtnText = ORG_CODE_BTN_TEXT;
              this.setBtnEnable('code');
            }
          }, 1000);
        });
      } else {
        this.$toast.fail('请正确输入手机号码');
      }
    },
    authCode() {
      if (this.verCode && this.phoneNum && this.isvalidPhone(this.phoneNum)) {
        getStudioDetail({
          sms_code: this.verCode,
          phone: this.phoneNum,
          json: 1,
        }).then(res => {
          if (res.code === 0) {
            sessionStorage.setItem('studioBaseInfo', JSON.stringify(res.data));
            this.$router.push({
              name: 'settingsEntry',
              params: { activeName: 'vipInfo', jumpTabsChangeCheck: true },
            });
          } else {
            this.$toast.fail(res.message);
          }
        });
      } else {
        if (!this.verCode) {
          this.$toast.fail('请输入短信验证码');
        } else {
          this.$toast.fail('请填写手机号');
        }
      }
    },
    setBtnEnable(type) {
      // this[type + 'BtnType'] = 'primary';
      this[type + 'BtnStatus'] = false;
    },
    setBtnDisabled(type) {
      // this[type + 'BtnType'] = 'info';
      this[type + 'BtnStatus'] = true;
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.container {
  .block {
    min-height: calc(100vh - 125px);
    // min-height: 800px;
    .content-inner-wrap {
      .vailCodeInput {
        ::v-deep input {
          height: 56px;
          width: 220px;
        }
        button {
          width: 156px;
          height: 56px;
          font-size: 24px;
          padding: 0;
          white-space: nowrap;
        }
      }
      .getCodeBtn {
        width: 180px;
      }
      .updateTips {
        text-align: center;
        font-size: 24px;
        font-family: MicrosoftYaHei;
        color: #262626;
        line-height: 1.8;
        margin: 60px;
      }
      .largeCenterBtn {
        margin-top: 111px;
        width: 502px;
        height: 70px;
        font-size: 28px;
        line-height: 38px;
      }
    }
  }
}
</style>
